import React from 'react';
import { impactMetrics } from '../../data/capabilities';
import { SectionHeading } from '../SectionHeading';
export function ImpactMetrics() {
  return <section id="impact" className="w-full bg-navy-900 py-20 text-white lg:py-28" data-id="element-131" data-mp="12aeowftn1qev">
      <div className="mx-auto max-w-shell px-6 lg:px-10" data-id="element-132" data-mp="xg0mhtgk6j0p">
        <SectionHeading title="Executive Impact & Capital Metrics" intro="The three numbers that describe two decades of stewardship." tone="dark" data-id="element-133" data-mp="sj0g1hfsre92" />

        <dl className="mt-16 grid grid-cols-1 divide-y divide-white/15 lg:grid-cols-3 lg:divide-x lg:divide-y-0" data-id="element-134" data-mp="ji2bmy1g54py">
          {impactMetrics.map(metric => <div key={metric.title} className="flex flex-col py-10 lg:px-10 lg:py-0 lg:first:pl-0 lg:last:pr-0" data-id="element-135" data-mp="eizfk33g28u4">
              <dt className="font-display text-5xl font-semibold tracking-tightest text-gold-400 lg:text-6xl" data-id="element-136" data-mp="28x0hwxy7ddyy">
                {metric.value}
              </dt>
              <p className="mt-6 text-xs font-semibold uppercase tracking-[0.14em] text-white/55" data-id="element-137" data-mp="23vuoexwpxmod">
                {metric.title}
              </p>
              <dd className="mt-3 text-[15px] leading-relaxed text-white/80" data-id="element-138" data-mp="2ay79lxfydu12">
                {metric.detail}
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}